// extracted by mini-css-extract-plugin
export default {"eventBlock":"calendar-event-ui_eventBlock__7+9SE"};